import React from 'react';
import {
    Modal,
    Box,
    Typography,
    TextField,
    Button,
    FormControl,
} from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

const Takedown = ({ open, handleClose, submitRequest, takedown_date, takedownHandler }) => {

    return (
        <Modal open={open} >
            <Box
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 600,
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    p: 4,
                    borderRadius: 2
                }}
            >
                <Typography variant="h6" gutterBottom>
                    Take Down
                </Typography>

                <Box display={'flex'} alignItems={'center'} gap={2} >
                    <FormControl fullWidth={true} >
                        <LocalizationProvider
                            dateAdapter={AdapterDayjs}>
                            <DatePicker
                                views={['year', 'month', 'day']}
                                label="Takedown Date"
                                onChange={takedownHandler}
                                renderInput={(params) => <TextField size="small" sx={{ minWidth: "100%", backgroundColor: '#F6F6F6', mt: 1 }} {...params} />}
                            />
                        </LocalizationProvider>
                    </FormControl>
                </Box>

                <Box display={'flex'} alignItems={'center'} justifyContent={'end'} gap={2} mt={2}>
                    <Button
                        variant="text"
                        className='gn-actionbtn-color'
                        onClick={handleClose}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="contained"
                        className='gn-actionbtn'
                        onClick={submitRequest}
                    >
                        Takedown
                    </Button>
                </Box>
            </Box>
        </Modal>
    );
};

export default Takedown;
